<template>
  <div style="padding: 10px">
    <!-- <div class="content-title">
      <div
        @click="tabClick(item, index)"
        class="content-item"
        :class="{ active: index == num }"
        v-for="(item, index) in tabList"
        :key="index"
      >
        <div>
          {{ item.label }}
        </div>
      </div>
    </div>
    <el-divider class="divider" />
    <div>
      <component :is="compName" />
    </div> -->
    <TableConfig />
  </div>
</template>
<script>
import BaseInfo from "./baseInfo.vue";
import GenerateTable from "./generateTable.vue";
import TableConfig from "./tableConfig/index.vue";
export default {
  data() {
    return {
      compName: "",
      tabList: [
        { label: "基本信息", value: 5, componentName: "BaseInfo" },
        { label: "第一页", value: 0, componentName: "GenerateTable" },
        { label: "第二页", value: 1, componentName: "GenerateTable" },
        { label: "第三页", value: 2, componentName: "GenerateTable" },
        { label: "表格自定义", value: 3, componentName: "TableConfig" },
      ],
      num: 0,
      loading: false,
    };
  },
  components: { TableConfig, BaseInfo, GenerateTable },
  methods: {
    tabClick(item, index) {
      this.num = index;
      this.compName = item.componentName;
    },
  },
};
</script>
<style scoped lang="scss">
.divider {
  margin: 6px 0;
}

.content-title {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.6em;

  .content-item {
    cursor: pointer;
    font-size: 12px;
    padding: 6px 10px;
    // border-bottom: solid 2px #eee;

    &:hover {
      color: var(--themeColor);
      border-bottom: solid 2px var(--themeColor);
    }

    &.active {
      color: var(--themeColor);
      border-bottom: solid 2px var(--themeColor);
    }
  }
}
</style>